import { isNumber } from 'lodash';

export const removeDecimalsFromAmount = amount => {
  if (!amount) return 0;

  if (isNumber(amount)) {
    return amount;
  }

  const number = amount
    .replace(/^[A-Za-z$€£¥\s]+/g, '')
    .replace(/[^\d.,]/g, '')
    .replace(/,/g, '');

  return parseFloat(number) || 0;
};

export const debounce = (func, delay) => {
  let timeoutId;

  return function(...args) {
    const context = this;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
};

export const isTextTruncated = element => {
  if (!element) return false;
  return element.scrollWidth > element.clientWidth;
};

export const utils = {
  removeDecimalsFromAmount
};
